import { STORAGE_TOKEN_KEY } from 'configs/constant'
import { LOGIN } from 'configs/path'
import { useAppSelector } from 'hooks'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Navigate, Outlet, useParams } from 'react-router-dom'
import { getAppSetting } from 'services/appService'
import { setAppSetting } from '../redux/slices/appSlice'
import { bindParams, checkLogin } from '../utilities/helpers'
import LoginPage from './login/Login'
import useExpandExpiredToken from 'hooks/useExpandExpridToken'

const PrivateRouter = () => {
  const { app } = useParams()
  const { app_id } = useAppSelector((s) => s.app)
  const dispatch = useDispatch()
  useExpandExpiredToken()

  const handleGetAppSetting = async () => {
    const appSetting = await getAppSetting({ app_id: app as string })
    if (appSetting.success) {
      dispatch(setAppSetting(appSetting.data))
    }
  }

  const PrivateComponent = () => {
    if (!!app && app !== app_id) {
      localStorage.removeItem(STORAGE_TOKEN_KEY)
      return <LoginPage />
    } else if (checkLogin()) {
      return <Outlet />
    } else {
      return (
        <Navigate
          to={bindParams(LOGIN, {
            app: app
          })}
        />
      )
    }
  }

  useEffect(() => {
    handleGetAppSetting()
  }, [])

  return <PrivateComponent />
}

export default PrivateRouter
